// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._14wy7po0 {
  height: 100%;
}
._14wy7po1 {
  max-width: 380px;
  width: 100%;
}
._14wy7po3:before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: var(--_18w76bw2a);
  position: absolute;
  top: 14px;
}
._14wy7po4 {
  color: var(--_18w76bw31);
  z-index: var(--_18w76bw53);
  padding-left: var(--_18w76bwc);
  padding-right: var(--_18w76bwc);
  text-align: center;
  position: relative;
  align-self: center;
  background-color: var(--_18w76bw27);
}
._14wy7po5 {
  color: var(--_18w76bw2g);
  text-align: center;
  align-self: center;
}
@media screen and (min-width: 768px) {
  ._14wy7po1 {
    width: auto;
    padding-left: var(--_18w76bwo);
    padding-right: var(--_18w76bwo);
  }
  ._14wy7po3:before {
    top: 22px;
  }
}
@media screen and (min-width: 769px) {
  ._14wy7po2 {
    padding: 0 10px;
  }
}
@media screen and (max-width: 768px) {
  ._14wy7po2 {
    padding: 0 5px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["._14wy7po0 {\n  height: 100%;\n}\n._14wy7po1 {\n  max-width: 380px;\n  width: 100%;\n}\n._14wy7po3:before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1px;\n  background: var(--_18w76bw2a);\n  position: absolute;\n  top: 14px;\n}\n._14wy7po4 {\n  color: var(--_18w76bw31);\n  z-index: var(--_18w76bw53);\n  padding-left: var(--_18w76bwc);\n  padding-right: var(--_18w76bwc);\n  text-align: center;\n  position: relative;\n  align-self: center;\n  background-color: var(--_18w76bw27);\n}\n._14wy7po5 {\n  color: var(--_18w76bw2g);\n  text-align: center;\n  align-self: center;\n}\n@media screen and (min-width: 768px) {\n  ._14wy7po1 {\n    width: auto;\n    padding-left: var(--_18w76bwo);\n    padding-right: var(--_18w76bwo);\n  }\n  ._14wy7po3:before {\n    top: 22px;\n  }\n}\n@media screen and (min-width: 769px) {\n  ._14wy7po2 {\n    padding: 0 10px;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._14wy7po2 {\n    padding: 0 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
